// Pfade sind relativ (ohne PUBLIC_URL und ohne Country-Prefix);
// SidebarMenuItems hängt das via useCountryPath() dynamisch an.
export const MENUITEMS = [
  {
    menutitle: 'General',
    menucontent: 'Dashboards,Widgets',
    Items: [
      {
        title: 'Home',
        icon: 'home',
        path: `/pages/home`,
        type: 'link',
      },
      {
        title: 'Tickets',
        icon: 'sample-page',
        path: `/pages/tickets`,
        type: 'link',
      },
      {
        title: 'Concern',
        icon: 'form',
        // path: `/pages/concern`,
        type: 'link',
      },
    ],
  },
];